/* White Friday month helpers: card badges (4), product strip countdown (5). Remove after 30 Nov 2026.
   The cart nudge toward the 2-piece offers was removed on 2026-10-30: those offers stopped on 2026-10-27. */
(function () {
  var AR = (document.documentElement.lang || '').indexOf('ar') === 0;
  var END = Date.parse('2026-11-30T21:59:00Z');
  // Percent off per White Friday product, worked out from today's Shopify prices in sections/elite-wf-global.liquid.
  var PCT = window.elWfPct || {};
  var HANDLES = Object.keys(PCT).filter(function (h) { return h !== '_'; });
  if (!HANDLES.length) HANDLES = ['haven-milton-set', 'cove-milton-set', 'flame-gabardine-hooded-zip-jacket', 'dot-gabardine-polka-jacket', 'ridge-gabardine-jacket', 'essential-cotton-wide-leg-pants'];
  function handleOf(href) { var m = /\/products\/([a-z0-9-]+)/.exec(href || ''); return m ? m[1] : null; }

  // (4) badge on every product card that links to a White Friday product
  function badges(scope) {
    var links = (scope || document).querySelectorAll('a[href*="/products/"]');
    for (var i = 0; i < links.length; i++) {
      var h = handleOf(links[i].getAttribute('href'));
      if (!h || HANDLES.indexOf(h) < 0) continue;
      var card = links[i].closest('.card-wrapper, .card, .el-card, .el-prod, .product-card, li, article');
      if (!card || card.querySelector('.el-wf-badge') || card.closest('[data-wf]')) continue;
      var media = card.querySelector('.card__media, .card__inner, .el-card__media, .el-prod__media, picture, img');
      var host = media ? (media.closest('.card__inner') || media.parentElement) : card;
      if (!host) host = card;
      if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
      var b = document.createElement('span');
      b.className = 'el-wf-badge';
      b.innerHTML = (AR ? 'وايت فرايدي' : 'WHITE FRIDAY') + (PCT[h] ? '<small>-' + PCT[h] + '%</small>' : '');
      host.appendChild(b);
    }
  }

  // (5) product strip countdown
  function strip() {
    var els = document.querySelectorAll('[data-wf-strip-clock]');
    if (!els.length) return;
    function two(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var left = END - Date.now();
      for (var i = 0; i < els.length; i++) {
        if (left <= 0) { els[i].textContent = AR ? 'خلص' : 'Ended'; els[i].classList.add('is-over'); continue; }
        var d = Math.floor(left / 864e5), h = Math.floor(left % 864e5 / 36e5), m = Math.floor(left % 36e5 / 6e4);
        els[i].textContent = (AR ? d + ' يوم ' + two(h) + ':' + two(m) : d + 'd ' + two(h) + ':' + two(m));
      }
      setTimeout(tick, 30000);
    }
    tick();
  }

  // Old offer notes left in an open cart drawer from the previous version.
  function clearNudges() { var olds = document.querySelectorAll('.el-wf-nudge'); for (var i = 0; i < olds.length; i++) olds[i].remove(); }

  function init() {
    badges(document);
    strip();
    clearNudges();
    new MutationObserver(function (ms) { for (var i = 0; i < ms.length; i++) if (ms[i].addedNodes.length) { badges(document); break; } }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
